<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card>
          <h1 class="mb-3">لیست زبان ها</h1>
          <div class="my-2">
            <!-- Table Top Start -->
            <b-row>
              <!-- Search -->
              <b-col cols="12" md="5">
                <div
                  class="d-flex flex-column flex-md-row align-items-center justify-content-end"
                >
                  <b-form-group
                    class="d-inline-block w-100"
                    label="جستجو کنید"
                    label-for="questionLevel"
                  >
                    <b-form-input
                      v-model="searchCommand"
                      class="d-inline-block"
                      placeholder="جستجو..."
                      @keydown.enter="setPageNumberAndGetAllLanguages"
                    />
                  </b-form-group>
                  <b-button
                    variant="primary"
                    class="ml-1"
                    @click="setPageNumberAndGetAllLanguages"
                  >
                    اعمال
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </div>
          <b-table
            ref="refUserListTable"
            class="position-relative"
            :items="languagesList"
            responsive
            :fields="myTableColumns"
            primary-key="id"
            show-empty
            bordered
            striped
            empty-text="موردی موجود نیست!"
          >
            <template #cell(createDate)="data">
              {{ new Date(data.item.createDate).toLocaleDateString("fa-IR") }}
            </template>
            <template #cell(Edit)="data">
              <!-- <div
                @click="renderEditModal(data.item)"
                v-b-modal.modal-edit
                style="cursor: pointer"
              > -->
              <div
                class="w-auto d-flex align-items-center justify-content-center"
              >
                <b-link :to="`/languages/${data.item.languageId}`">
                  <feather-icon
                    class="text-primary"
                    icon="EditIcon"
                    size="20"
                  />
                </b-link>
              </div>
              <!-- </div> -->
            </template>
            <template #cell(Lesson)="data">
              <div
                class="w-auto d-flex align-items-center justify-content-center"
              >
                <b-link :to="`/languages/${data.item.languageId}/lessons`">
                  <feather-icon
                    class="text-info"
                    icon="BookOpenIcon"
                    size="20"
                  />
                </b-link>
              </div>
            </template>
            <template #cell(Delete)="data">
              <div
                class="w-auto d-flex align-items-center justify-content-center"
              >
                <div
                  style="cursor: pointer"
                  @click="renderDeleteConfirmation(data.item.languageId)"
                  v-b-modal.modal-delete
                >
                  <feather-icon
                    class="text-danger"
                    icon="Trash2Icon"
                    size="20"
                  />
                </div>
              </div>
            </template>
          </b-table>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end py-2"
          >
            <b-pagination
              v-model="pageNumber"
              :total-rows="totalCount"
              :per-page="count"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  style="transform: rotate(180deg)"
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      id="modal-delete"
      centered
      ok-title="بله"
      cancelTitle="خیر"
      @ok="deleteALanguage"
    >
      <span>آیا از حذف کردن این زبان اطمینان دارید ؟ </span>
    </b-modal>
    <b-modal
      id="modal-edit"
      centered
      ok-title="بله"
      cancelTitle="خیر"
      @ok="updateALang"
    >
      <b-form class="p-2" @submit.prevent v-if="tempLanguageObject">
        <!-- Language Eng Title -->
        <b-form-group label="نام انگلیسی زبان" label-for="lang-eng">
          <b-form-input
            id="lang-eng"
            v-model="tempLanguageObject.title"
            trim
            placeholder="English"
          />
        </b-form-group>

        <!-- Language Persian Title -->
        <b-form-group label="نام فارسی زبان" label-for="persian-title">
          <b-form-input
            id="persian-title"
            v-model="tempLanguageObject.persianTitle"
            trim
            placeholder="انگلیسی"
          />
        </b-form-group>
      </b-form>
    </b-modal>
  </b-overlay>
</template>
<script>
import {
  GetAllLanguages,
  DeleteALanguage,
  UpdateALanguage,
} from "../../../libs/Api/Language";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BForm,
  BFormGroup,
  BButton,
  BTable,
  BModal,
  BLink,
  BPagination,
  BOverlay,
} from "bootstrap-vue";
export default {
  mounted() {
    this.getAllLanguages();
  },
  watch: {
    pageNumber: {
      handler(val) {
        this.getAllLanguages();
      },
    },
  },
  data() {
    return {
      isLoading: false,
      languagesList: null,
      totalCount: null,
      pageNumber: 1,
      count: 10,
      searchCommand: null,
      tempLanguageId: null,
      tempLanguageObject: null,
      myTableColumns: [
        {
          key: "languageId",
          label: "شناسه زبان",
        },
        {
          key: "persianTitle",
          label: "نام فارسی",
        },
        {
          key: "title",
          label: "نام انگلیسی",
        },
        {
          key: "createDate",
          label: "تاریخ ثبت",
        },
        {
          key: "Edit",
          label: "ویرایش",
        },
        {
          key: "Lesson",
          label: "افزودن درس",
        },
        {
          key: "Delete",
          label: "حذف",
        },
      ],
    };
  },
  methods: {
    async updateALang() {
      let _this = this;
      let updateALanguage = new UpdateALanguage(_this);
      updateALanguage.setRequestParamDataObj(_this.tempLanguageObject);
      await updateALanguage.fetch(
        function (response) {
          _this.getAllLanguages();
          _this.tempLanguageObject = null;
          _this.$toast({
            component: ToastificationContent,
            props: {
              title: "ویرایش با موفقیت انجام شد",
              icon: "EditIcon",
              variant: "success",
            },
          });
        },
        function (error) {
          console.error(error);
        }
      );
    },
    renderEditModal(lang) {
      this.tempLanguageObject = JSON.parse(JSON.stringify(lang));
    },
    renderDeleteConfirmation(languageId) {
      this.tempLanguageId = languageId;
    },
    async deleteALanguage() {
      let _this = this;
      let deleteALanguage = new DeleteALanguage(_this);
      deleteALanguage.setRequestParam({
        id: _this.tempLanguageId,
      });
      await deleteALanguage.fetch(
        function (response) {
          _this.tempLanguageId = null;
          _this.$toast({
            component: ToastificationContent,
            props: {
              title: "حذف با موفقیت انجام شد",
              icon: "Trash2Icon",
              variant: "success",
            },
          });
          _this.getAllLanguages();
        },
        function (error) {
          console.error(error);
        }
      );
    },
    setPageNumberAndGetAllLanguages() {
      this.pageNumber = 1;
      this.getAllLanguages();
    },
    async getAllLanguages() {
      try {
        this.isLoading = true;
        let _this = this;
        let getAllLanguages = new GetAllLanguages(_this);
        let qParams = {
          count: _this.count,
          pageNumber: _this.pageNumber,
        };
        if (this.searchCommand) {
          qParams["searchCommand"] = this.searchCommand;
        }
        getAllLanguages.setRequestParam(qParams);
        await getAllLanguages.fetch(
          function (response) {
            if (response.isSuccess) {
              _this.languagesList = response.data.languages;
              _this.totalCount = response.data.languagesCount;
            }
          },
          function (error) {
            console.error(error);
          }
        );
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BModal,
    BButton,
    BForm,
    BFormGroup,
    BTable,
    BLink,
    BPagination,
    BOverlay,
  },
};
</script>
